import { sendContactMessageAction } from 'redux/actions/contactMessageActions';
import { generateSimpleRequestReducer } from 'redux/utils/requestWithoutData';

export default generateSimpleRequestReducer(sendContactMessageAction);
